import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Img } from "@sunwing/shared-components";
import styles from "./CardLogo.module.scss";

const CardLogo = ({ className, style, logo, logoPosition, imageComponentProps }) => (
	<>
		{logo && (
			<div className={cx(styles.logoContainer, className)} style={style}>
				<Img
					wrapperClassName={cx(styles.logo, styles[`logo--${logoPosition || "top-left"}`])}
					fluid={logo?.fluid}
					src={logo?.src || logo.secure_url}
					source={logo?.srcSet && logo}
					alt={logo?.alt}
					{...imageComponentProps}
				/>
			</div>
		)}
	</>
);

CardLogo.propTypes = {
	className: PropTypes.string,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
	logo: PropTypes.object,
	logoPosition: PropTypes.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
	imageComponentProps: PropTypes.object,
};

CardLogo.defaultProps = {
	className: "",
	style: {},
	logo: undefined,
	logoPosition: undefined,
	imageComponentProps: {},
};

export default CardLogo;
export { CardLogo };
